export default __webpack_public_path__ + "static/media/fw-mia-er-Rose Gold.d4f4a360.mp4";